
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryDialog extends Serenity.EntityDialog<EnquiryRow, any> {
        protected getFormKey() { return EnquiryForm.formKey; }
        protected getIdProperty() { return EnquiryRow.idProperty; }
        protected getLocalTextPrefix() { return EnquiryRow.localTextPrefix; }
        protected getNameProperty() { return EnquiryRow.nameProperty; }
        protected getService() { return EnquiryService.baseUrl; }
        protected getDeletePermission() { return EnquiryRow.deletePermission; }
        protected getInsertPermission() { return EnquiryRow.insertPermission; }
        protected getUpdatePermission() { return EnquiryRow.updatePermission; }

        protected form = new EnquiryForm(this.idPrefix);

        constructor() {
            super();

            $('<a class="inplace-button inplace-action3"><b><i class="fa fa-magic text-red"></i></b></a>')
                .attr("title", "Select Product")
                .insertAfter(this.form.EnquiryProducts.element)
                .click(e => {
                    var dlg = new EnquiryProductsPickerDialog({
                        hideProducts: this.form.EnquiryProducts.values
                    });
                    var SelectedOrderproduct;
                    dlg.onSuccess = (selected) => {
                        debugger;
                        // filter already existing products
                        // selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.QuestionId == x.Id));

                        for (var sel of selected) {
                            var items = items + "," + sel.Id.toString();
                        }                        
                        this.form.EnquiryProducts.set_value(items);
                        //this.form.EnquiryProducts.set_readOnly(true);
                        return true;
                    };
                    dlg.dialogOpen();
                });
        }

        private seCustomDetails(details: Enquiry.EnquiryRow) {

            this.form.CustomerId.value = details.CustomerId.toString();
            this.form.Mobile1.value = details.Mobile1;

            this.form.EmailId1.value = details.EmailId1;
            this.form.Address1.value = details.Address1;

            //this.form.City.value = details.City;
            //this.form.Country.value = details.Country;
            //this.form.StateId.value = details.StateId.toString();
        }

        loadEntity(entity: EnquiryRow) {
            super.loadEntity(entity);
            //debugger;
            if (this.isNew()) {
                //this.form.HandledBy.value = '2';
                this.form.EStatus.value = '2';
                if (Authorization.hasPermission("Administration:Security"))
                {
                    this.form.HandledBy.set_value("");
                }
                else if (Authorization.hasPermission("Users:Manager") || Authorization.hasPermission("Users:SalesExecutive") ||
                    Authorization.hasPermission("Users:TechSupport"))
                {
                    this.form.HandledBy.set_value(this.form.HandledBy.items[0].id);
                }
            }            

            this.form.CustomerId.change(e => {
                var vcustomerId = this.form.CustomerId.value;

                if (Q.isEmptyOrNull(vcustomerId)) {
                    // this.setProductDetails({});
                }
                else {
                    try {
                        Enquiry.EnquiryService.GetDetail({
                            CustomerId: parseInt(vcustomerId)
                        }, response => {
                            this.form.CustomerId.value = this.form.CustomerId.value;
                            this.form.EnquiryName.value = response.CustomerName;
                            this.form.EmailId1.value = response.CustomerEmail1;
                            this.form.Mobile1.value = response.CustomerMobile1;
                            this.form.Address1.value = response.Address;
                            this.form.City.value = response.City;
                            this.form.StateId.value = response.State.toString();
                            this.form.Country.value = response.Country;
                            this.form.Pincode.value = parseInt(response.Pincode);
                        });
                    } catch (e) {
                    }
                }
            });
            this.form.EStatus.changeSelect2(e => {
                var vEstatus = this.form.EStatus.value;
                if (Q.isEmptyOrNull(vEstatus)) {
                    this.form.FollowupDate.getGridField().toggle(false);
                    this.form.FollowUpTime.getGridField().toggle(false);
                }

                if (vEstatus == '2') {
                    this.form.EnquiryType.value = '2';
                    this.form.FollowupDate.getGridField().toggle(true);
                    this.form.FollowUpTime.getGridField().toggle(true);
                }
                else {
                    this.form.FollowupDate.getGridField().toggle(false);
                    this.form.FollowUpTime.getGridField().toggle(false);
                }
            });
        }
    }
}